import { platformRead } from './http'

// 都是只读查询；统一走项目代理和登录态，不写死平台域名。
export const getDevicePropertyLatest = (deviceId, property, options = {}) => platformRead({
  method: 'get',
  url: `/jetlinks/device-instance/${encodeURIComponent(deviceId)}/property/${encodeURIComponent(property)}`
}, options)

export const queryDevicePropertyHistory = (deviceId, property, data, options = {}) => platformRead({
  method: 'post',
  url: `/jetlinks/device-instance/${encodeURIComponent(deviceId)}/property/${encodeURIComponent(property)}/_query`, data
}, options)

export const queryDevicePropertyAggregation = (deviceId, data, options = {}) => platformRead({
  method: 'post', url: `/jetlinks/device-instance/${encodeURIComponent(deviceId)}/agg/_query`, data
}, options)

export const getChartDevice = (id, options = {}) => platformRead({
  method: 'get', url: `/jetlinks/device-instance/${encodeURIComponent(id)}/detail`
}, options)

export const getChartProduct = (id, options = {}) => platformRead({
  method: 'get', url: `/jetlinks/device-product/${encodeURIComponent(id)}`
}, options)
